module.exports = __webpack_public_path__ + "img/80.0efd1af9.jpg";